export default {
      id: "chevrons-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#chevrons-down",
      toString: function () {
        return this.url;
      }
    }